module.exports = __webpack_public_path__ + "img/gradient-footer2_comp.0c2ef7e3.svg";